import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

const ModalCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M1.46154 19L0 17.5385L8.03846 9.5L0 1.46154L1.46154 0L9.5 8.03846L17.5385 0L19 1.46154L10.9615 9.5L19 17.5385L17.5385 19L9.5 10.9615L1.46154 19Z"
      fill="black"
    />
  </svg>
);

const AddTagModal = ({
  show,
  onHide,
  newTag,
  onNewTagChange,
  onAddTag,
  tags,
  onRemoveTag,
  onSaveTags
}) => {
  const getTagLabel = tag =>
    typeof tag === "string" || typeof tag === "number"
      ? String(tag)
      : (tag && (tag.label || tag.name || tag.title || tag.value || tag.id)) ||
        "";

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={true}
      dialogClassName="cms-articles-tag-dialog"
      className="cms-articles-tag-modal"
    >
      <div className="cms-articles-tag-panel">
        <div className="cms-articles-tag-panel__header">
          <h2 className="cms-articles-tag-panel__title">Manage Tags</h2>
          <button
            type="button"
            className="cms-articles-tag-panel__close"
            onClick={onHide}
            aria-label="Close"
          >
            <ModalCloseIcon />
          </button>
        </div>

        <div className="cms-articles-tag-panel__body">
          <div className="cms-articles-tag-entry">
            <Form.Control
              type="text"
              placeholder="Add New Tag"
              value={newTag}
              onChange={onNewTagChange}
              className="cms-articles-tag-input"
            />
            <Button
              className="btn-orange cms-articles-add-tag-btn"
              onClick={onAddTag}
              disabled={!newTag.trim()}
            >
              <span className="add_tag_btn">+</span> Add
            </Button>
          </div>

          <div className="cms-articles-tag-section">
            <div className="cms-articles-tag-list-title">
              Existing Tags <span>({tags.length})</span>
            </div>

            <div className="cms-articles-tag-list">
              {tags.map((tag, index) => {
                const tagLabel = getTagLabel(tag);

                return (
                  <button
                    type="button"
                    key={`${tagLabel}-${index}`}
                    className="cms-articles-tag-chip"
                    onClick={() => onRemoveTag(index)}
                  >
                    <span className="cms-articles-tag-chip__text">
                      {tagLabel}
                    </span>
                    <span className="cms-articles-tag-chip__close">
                      &times;
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="cms-articles-tag-panel__footer">
          <Button
            variant="outline"
            className="cms-articles-cancel-btn"
            onClick={onHide}
          >
            CANCEL
          </Button>
          <Button
            className="btn-orange cms-articles-save-btn"
            onClick={onSaveTags}
          >
            SAVE CHANGES
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddTagModal;
